var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicalResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCC0D8;}\n\t.st1{fill:#E09F0D;}\n\t.st2{fill:#243193;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.7,512H112.3c-31.4,0-57-25.6-57-57V57c0-31.4,25.6-57,57-57H315c14.5,0,28.4,5.5,39,15.4l84.6,79.3 c11.4,10.7,18,25.9,18,41.6v187.2c0,7.6-6.2,13.8-13.8,13.8s-13.8-6.2-13.8-13.8V136.3c0-8.1-3.4-15.9-9.3-21.4l-84.6-79.3 c-5.5-5.1-12.6-7.9-20.1-7.9H112.3C96.2,27.7,83,40.8,83,57v398c0,16.2,13.2,29.3,29.3,29.3h287.3c16.2,0,29.3-13.2,29.3-29.3 v-54.8c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8V455C456.6,486.4,431.1,512,399.7,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,407.8c-7.6,0-13.8-6.2-13.8-13.8v-54.6c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8V394 C269.8,401.6,263.6,407.8,256,407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.3,380.5h-54.6c-7.6,0-13.8-6.2-13.8-13.8s6.2-13.8,13.8-13.8h54.6c7.6,0,13.8,6.2,13.8,13.8 C297.1,374.3,290.9,380.5,283.3,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,457.3c-50,0-90.6-40.7-90.6-90.6s40.7-90.6,90.6-90.6c15.3,0,30.4,3.9,43.7,11.2 c6.7,3.7,9.1,12.1,5.4,18.8c-3.7,6.7-12.1,9.1-18.8,5.4c-9.2-5.1-19.7-7.8-30.3-7.8c-34.7,0-63,28.2-63,63s28.2,63,63,63 s63-28.2,63-63c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8C346.6,416.7,306,457.3,256,457.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328,214.5H184c-18,0-32.6-14.6-32.6-32.6v-45.5c0-18,14.6-32.6,32.6-32.6h144c18,0,32.6,14.6,32.6,32.6v45.5 C360.6,199.9,346,214.5,328,214.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328,228.3H184c-25.6,0-46.4-20.8-46.4-46.4v-45.5c0-25.6,20.8-46.4,46.4-46.4h144c25.6,0,46.4,20.8,46.4,46.4 v45.5C374.4,207.5,353.6,228.3,328,228.3z M184,117.6c-10.3,0-18.8,8.4-18.8,18.8v45.5c0,10.3,8.4,18.8,18.8,18.8h144 c10.3,0,18.8-8.4,18.8-18.8v-45.5c0-10.3-8.4-18.8-18.8-18.8C328,117.6,184,117.6,184,117.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalResult);
export default __webpack_public_path__ + "static/media/medical-result.b9833d164adbeae606b189700626aa89.svg";
export { ForwardRef as ReactComponent };